import { FieldBase } from './field-base.interface'

export class HiddenField extends FieldBase<string> {
  controlType = 'hidden'

  constructor(options: {} = {}) {
    super(options)
  }
}
